import { useState, useEffect } from 'react';
import ApiService from '../../service/ApiService';
import { apiPaths } from '../../service/apiPaths';
import toast from 'react-hot-toast';

const useAboutUs = () => {
    const [sections, setSections] = useState([
        {
            title: '',
            textFields: [{ text: '' }],
            subtitles: [
                {
                    subtitle: '',
                    textFields: [{ text: '' }]
                }
            ],
        }
    ]);

    useEffect(() => {
        fetchSections();
    }, []);

    const fetchSections = async () => {
        try {
            const response = await ApiService({
                method: 'GET',
                endpoint: apiPaths.aboutUs,
            });
            setSections(response.titles);
        } catch (error) {
            console.error('Error fetching sections:', error);
        }
    };

    const handleSectionChange = (index: number, field: 'title' | 'textFields', value: string) => {
        const newSections = [...sections];
        if (field === 'title') {
            newSections[index].title = value;
        } else {
            newSections[index].textFields = [{ text: value }];
        }
        setSections(newSections);
    };

    const handleSubtitleChange = (sectionIndex: number, subtitleIndex: number, field: 'subtitle' | 'textFields', value: string) => {
        const newSections = [...sections];
        if (field === 'subtitle') {
            newSections[sectionIndex].subtitles[subtitleIndex].subtitle = value;
        } else {
            newSections[sectionIndex].subtitles[subtitleIndex].textFields = [{ text: value }];
        }
        setSections(newSections);
    };

    const handleTextFieldChange = (sectionIndex: number, subtitleIndex: number, textFieldIndex: number, value: string) => {
        const newSections = [...sections];
        newSections[sectionIndex].subtitles[subtitleIndex].textFields[textFieldIndex].text = value;
        setSections(newSections);
    };

    const handleTitleTextFieldChange = (sectionIndex: number, textFieldIndex: number, value: string) => {
        const newSections = [...sections];
        newSections[sectionIndex].textFields[textFieldIndex].text = value;
        setSections(newSections);
    };

    const addSection = () => {
        const newSection = { title: '', subtitles: [{ subtitle: '', textFields: [{ text: '' }] }], textFields: [{ text: '' }] };
        setSections([...sections, newSection]);
    };

    const addSubtitle = (sectionIndex: number) => {
        const newSections = [...sections];
        const newSubtitle = { subtitle: '', textFields: [{ text: '' }] };
        newSections[sectionIndex].subtitles.push(newSubtitle);
        setSections(newSections);
    };

    const addTextField = (sectionIndex: number, subtitleIndex: number) => {
        const newSections = [...sections];
        const newTextField = { text: '' };
        newSections[sectionIndex].subtitles[subtitleIndex].textFields.push(newTextField);
        setSections(newSections);
    };

    const addTitleTextField = (sectionIndex: number) => {
        const newSections = [...sections];
        const newTextField = { text: '' };
        newSections[sectionIndex].textFields.push(newTextField);
        setSections(newSections);
    };

    const saveSections = async () => {
        console.log("Sections : ", sections)
        try {
            await ApiService({
                method: 'POST',
                endpoint: apiPaths.aboutUs,
                data: sections
            });
            toast.success('Sections saved successfully');
        } catch (error) {
            toast.error('Error saving sections');
            console.error('Error saving sections:', error);
        }
    };

    const deleteSection = (sectionIndex: number) => {
        const newSections = sections.filter((_, index) => index !== sectionIndex);
        setSections(newSections);
    };

    const deleteSubtitle = (sectionIndex: number, subtitleIndex: number) => {
        const newSections = [...sections];
        newSections[sectionIndex].subtitles = newSections[sectionIndex].subtitles.filter((_, index) => index !== subtitleIndex);
        setSections(newSections);
    };

    const deleteTextField = (sectionIndex: number, subtitleIndex: number, textFieldIndex: number) => {
        const newSections = [...sections];
        newSections[sectionIndex].subtitles[subtitleIndex].textFields = newSections[sectionIndex].subtitles[subtitleIndex].textFields.filter((_, index) => index !== textFieldIndex);
        setSections(newSections);
    };

    const deleteTitleTextField = (sectionIndex: number, textFieldIndex: number) => {
        const newSections = [...sections];
        newSections[sectionIndex].textFields = newSections[sectionIndex].textFields.filter((_, index) => index !== textFieldIndex);
        setSections(newSections);
    };

    const deleteAll = () => {
        setSections([
            {
                title: '',
                textFields: [{ text: '' }],
                subtitles: [
                    {
                        subtitle: '',
                        textFields: [{ text: '' }]
                    }
                ],
            }
        ]);
    }

    return {
        sections,
        handleSectionChange,
        handleSubtitleChange,
        handleTextFieldChange,
        handleTitleTextFieldChange,
        addSection,
        addSubtitle,
        addTextField,
        addTitleTextField,
        saveSections,
        deleteSection,
        deleteSubtitle,
        deleteTextField,
        deleteTitleTextField,
        deleteAll,
    };
}

export default useAboutUs;
